import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { SelectOption } from 'component-library-and-tools';

import SearchBar from 'shared/components/SearchBar';
import Select from 'shared/components/Select';

import { FilterBarProps } from './types';
import {
  SEARCH_FILTER_KEY,
  // STATUS_FILTER_KEY,
  TYPE_FILTER_KEY,
  WORKFLOW_TYPE_SELECT_OPTIONS,
} from './constants';

const StyledContainer = styled.div`
  display: flex;
  font-size: 1.166666667rem;
`;

const commonFilterStyles = css`
  &:not(:last-child) {
    margin-right: 1rem;
  }
`;

const StyledSearchBar = styled(SearchBar)`
  flex-basis: 76.4%;
  ${commonFilterStyles}
`;

const StyledSelect = styled(Select)`
  flex-basis: 23.61%;
  ${commonFilterStyles}
`;

const filter = (
  filterKey: string,
  filterValue: any,
  currentFilters: Object,
  setFilters: React.Dispatch<React.SetStateAction<Object>>,
  onFilter: FilterBarProps['onFilter'],
) => {
  const updatedFilters = {
    ...currentFilters,
    [filterKey]: filterValue,
  };

  setFilters(updatedFilters);
  onFilter(updatedFilters)
};

const FilterBar = ({
  className,
  onFilter,
}: FilterBarProps) => {
  const [filters, setFilters] = useState({});

  return (
    <StyledContainer className={className}>
      <StyledSearchBar
        placeholder='Search workflows...'
        delayToSearch={250}
        onSearch={(searchValue) => (
          filter(SEARCH_FILTER_KEY, searchValue, filters, setFilters, onFilter)
        )}
      />
      {/* Commented until back-end supports the field. */}
      {/* <StyledMultiSelect
        menuGap={4}
        options={[]}
        placeholder='Select status'
        allSelectedLabel='Status: All'
        onSelect={(selectedStatus) => (
          filter(STATUS_FILTER_KEY, selectedStatus, filters, setFilters, onFilter)
        )}
      /> */}
      <StyledSelect
        menuGap={4}
        options={WORKFLOW_TYPE_SELECT_OPTIONS}
        placeholder='Select type'
        onSelect={(option) => {
          const selectedType = option as SelectOption;

          filter(TYPE_FILTER_KEY, selectedType.name, filters, setFilters, onFilter);
        }}
      />
    </StyledContainer>
  );
};

export default FilterBar;
